export default {
    SAMPLE_VIEW: { id: 0 },
    MACRO_VIEW: { id: 1 },
    DIAGNOSIS_INTEGRAL_VIEW: { id: 2 },
    COMPLEMENTARIES_VIEW: { id: 3 }
}
